import { useState } from "react";
import { useV2GetAccountFinancialsQuery } from "@generated";

const useGetTotals = () => {
  const [isRefetching, setIsRefetching] = useState(false);

  const {
    data,
    isLoading,
    refetch: originalRefetch,
  } = useV2GetAccountFinancialsQuery();

  const refetch = async () => {
    setIsRefetching(true);
    await originalRefetch();
    setIsRefetching(false);
  };

  const totals = ((data) => {
    return {
      totalRevenue: Number(data?.data?.attributes["total-contract-value"]) || 0,
      averageRevenue:
        Number(data?.data?.attributes["average-contract-value"]) || 0,
      averageMargin:
        Number(data?.data?.attributes["average-contract-margin"]) || 0,
    };
  })(data);

  const combinedLoading = isLoading || isRefetching;

  return { isLoading: combinedLoading, totals, refetch };
};

export default useGetTotals;
